import { render, staticRenderFns } from "./ParametrosEstado.vue?vue&type=template&id=13833fa6&lang=pug"
import script from "./ParametrosEstado.vue?vue&type=script&lang=js"
export * from "./ParametrosEstado.vue?vue&type=script&lang=js"
import style0 from "./ParametrosEstado.vue?vue&type=style&index=0&id=13833fa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports